module.exports = __webpack_public_path__ + "static/media/sunrise-medical-logo-color.3cd61caa.svg";